<vdw-tag [value]="label | bmsTranslate" [color]="colorGetter[value]" [size]="size"></vdw-tag>
